<template>
  <div class="nav">
    <b-nav vertical class="w-25">
      <b-nav-item-dropdown text="Casal">
        <b-dropdown-item>
          <router-link to="/casal/cadastro">
            Cadastro Casal
          </router-link>
        </b-dropdown-item>
        <b-dropdown-item>
          <router-link to="/casal/lista">
            Lista Casal
          </router-link>
        </b-dropdown-item>
      </b-nav-item-dropdown>
      <b-nav-item>
        <router-link to="/about">
          Sobre
        </router-link>
      </b-nav-item>
      <b-nav-item>
        <router-link to="/login">
          <span v-on:click="logout">Sair</span>
        </router-link>
      </b-nav-item>
    </b-nav>
  </div>
</template>
<script>
import firebase from 'firebase/app';

export default {
  name: 'Menu',
  methods: {
    logout() {
      firebase.auth().signOut().then(() => {
        this.$router.replace('login');
      });
    },
  },
};

</script>
